module.exports = __webpack_public_path__ + "img/cattunnel21.24feca47.jpg";